import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_FAILED,
} from '../../constants';

import { fetchAccountOverview } from '../../actions/account-actions';

import store from '../../store';

const updateAccount = (action$, state$) =>
  action$.pipe(
    ofType(UPDATE_ACCOUNT),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/accounts/${action.accountId}?v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'PATCH',
      }).pipe(
        map(response => {
          store.dispatch(fetchAccountOverview());
          return {
            type: UPDATE_ACCOUNT_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: UPDATE_ACCOUNT_FAILED,
            error,
          })
        )
      )
    )
  );

export default updateAccount;
